import { create } from "zustand";
import { useShallow } from "zustand/shallow";
import { posthogConfig } from "../providers/posthog";

export type PosthogStatus = {
	isPosthogActive: boolean;
	setIsPosthogActive: (isActive: boolean) => void;
};

const usePosthogStatusStore = create<PosthogStatus>((set) => ({
	isPosthogActive: (posthogConfig?.apiKey?.length ?? 0) > 0,
	setIsPosthogActive: (isActive: boolean) => set({ isPosthogActive: isActive }),
}));

export const useSharedPosthogStatus = () =>
	usePosthogStatusStore(
		useShallow((s) => ({
			isPosthogActive: s.isPosthogActive,
			setIsPosthogActive: s.setIsPosthogActive,
		})),
	);
export default useSharedPosthogStatus;
